var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 34,
    viewBox: "0 0 139 34",
    width: 139,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.505 21.568H.742V.994h13.763z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 33.46h136.973V1H0z",
    id: "c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.987 11.891)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.899 3.128c-2.978 0-4.41 2.726-4.41 5.398 0 2.39 1.284 5.34 4.384 5.34 2.949 0 3.77-3.175 3.71-5.424.06-2.588-.703-5.314-3.684-5.314M.742 1.33h2.63v2.025h.057C4.159 2.285 5.855.994 8.484.994c4.325 0 6.021 3.4 6.021 7.25 0 3.936-1.493 7.76-5.991 7.76-2.63 0-4.12-.985-4.968-2.306H3.49v7.87H.742V1.33",
    fill: "#231F20",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.194 27.772h2.652V13.144h-2.652v14.628zm-.168-17.401h2.99V7.414h-2.99v2.957zM32.782 13.31h2.45v2.097h.056c1.002-1.671 2.421-2.44 4.51-2.44 1.644 0 3.287.853 4.037 2.81.975-2.07 3.12-2.81 4.402-2.81 3.62 0 4.928 2.385 4.928 5.532v9.273h-2.618V19.15c0-1.784-.418-4.024-2.535-4.024-2.673 0-3.73 2.663-3.73 5.356v7.29h-2.618V19.15c0-1.784-.418-4.024-2.532-4.024-2.674 0-3.732 2.663-3.732 5.356v7.29h-2.618V13.31M70.956 13.235h2.61v2.314h.058c.74-1.553 2.341-2.664 3.945-2.664.829 0 .833.087 1.43.203v2.461c-.506-.204-.662-.263-1.137-.263-2.49 0-4.119 2.343-4.119 6.095v6.39h-2.787V13.236M80.517 27.772h2.651V13.144h-2.651v14.628zm-.17-17.401h2.99V7.414h-2.99v2.957zM93.316 27.772h-3.162l-5.163-14.537h2.907l3.894 12.19h.057l3.979-12.19h2.653zM107.223 20.477c-.557 0-1.111-.061-1.669-.061-1.419 0-4.924.241-4.924 2.943 0 1.622 1.448 2.09 2.644 2.09 2.587 0 3.95-1.34 3.95-3.62v-1.352zm-7.76-6.127c1.308-.841 2.865-1.443 4.672-1.443 4.063 0 5.705 1.356 5.705 5.527v6.335c0 1.743.055 2.552.109 3.004h-2.447v-1.98h-.057c-.609.93-2.003 1.939-4.393 1.939-3.062 0-5.204-1.04-5.204-4.373 0-3.844 3.896-5.043 6.594-5.043 1.03 0 1.752 0 2.781.06 0-2.641-.887-3.186-3.504-3.186-1.476 0-3.06.6-4.117 1.561l-.14-2.401zM119.547 15.517h-3.81v7.768c0 1.73 1.015 2.261 2.228 2.261.82 0 1.412-.263 1.806-.528v2.343c-.592.177-1.41.41-2.258.41-2.736 0-4.429-.94-4.429-3.928v-8.326h-3.249v-2.226h3.249V9.427l2.652-.88v4.744h3.81v2.226M129.805 20.477c-.557 0-1.113-.061-1.67-.061-1.418 0-4.922.241-4.922 2.943 0 1.622 1.445 2.09 2.642 2.09 2.585 0 3.95-1.34 3.95-3.62v-1.352zm-7.76-6.127c1.305-.841 2.864-1.443 4.672-1.443 4.062 0 5.703 1.356 5.703 5.527v6.335c0 1.743.055 2.552.11 3.004h-2.448v-1.98h-.055c-.61.93-2.002 1.939-4.396 1.939-3.06 0-5.2-1.04-5.2-4.373 0-3.844 3.894-5.043 6.593-5.043 1.029 0 1.751 0 2.781.06 0-2.641-.89-3.186-3.504-3.186-1.476 0-3.062.6-4.12 1.561l-.137-2.401z",
    fill: "#231F20",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.345 5.252h5.535V1H7.345zM0 13.574h7.52v-6.34H0zM0 17.158h7.52v-3.1H0z",
    fill: "#E12242",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.857 9.185h6.545v-1.95H6.857zM0 20.744h7.52v-3.097H0zM12.723 20.744h7.536v-3.097h-7.536zM12.723 17.158h7.536v-3.1h-7.536z",
    fill: "#E12242",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.723 13.574h7.536v-6.34h-7.536zM0 27.638h7.508v-6.337H0z",
    fill: "#E12242",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.847 27.64h6.545v-2.125H6.847z",
    fill: "#E12242",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.715 27.638h7.534v-6.337h-7.534z",
    fill: "#E12242",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.705 14.133h.21c.248 0 .449-.082.449-.28 0-.178-.13-.296-.412-.296-.117 0-.2.013-.247.024v.552zm-.013 1.095h-.445V13.3c.177-.036.425-.058.742-.058.364 0 .528.058.668.14.107.082.188.235.188.422 0 .212-.164.378-.4.448v.024c.188.069.295.212.353.469.058.295.095.413.143.483h-.482c-.06-.07-.095-.247-.154-.471-.036-.213-.152-.306-.4-.306h-.213v.777zm-1.185-1.012c0 .859.635 1.54 1.504 1.54.845 0 1.469-.681 1.469-1.528 0-.857-.624-1.553-1.482-1.553-.856 0-1.49.696-1.49 1.541zm3.467 0c0 1.095-.857 1.953-1.976 1.953-1.103 0-1.983-.858-1.983-1.953 0-1.07.88-1.927 1.983-1.927 1.119 0 1.976.857 1.976 1.927z",
    fill: "#231F20",
    mask: "url(#d)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/DefaultLogo.833fc19d0adb028b8558dfb1956237eb.svg";
export { ForwardRef as ReactComponent };